const LAYOUT_MENU_ITEM_IDS = {
  Advertise: 21,
  Product: 27,
  BuilderTools: 28,
  BuyerDiscovery: 29,
  Resources: 30
};
const LAYOUT_MENU_ITEMS = [{
  parent: 0,
  id: LAYOUT_MENU_ITEM_IDS.Advertise,
  title: {
    rendered: "Advertise"
  },
  url: "/new-construction-advertising/",
  path: "/new-construction-advertising/"
}, {
  parent: 0,
  id: LAYOUT_MENU_ITEM_IDS.Product,
  title: {
    rendered: "Products"
  },
  url: "/new-construction-advertising/products/",
  path: "/new-construction-advertising/products/"
}, {
  parent: LAYOUT_MENU_ITEM_IDS.Product,
  id: LAYOUT_MENU_ITEM_IDS.BuilderTools,
  title: {
    rendered: "Builder Tools"
  },
  url: "/new-construction-advertising/builder-tools/",
  path: "/new-construction-advertising/builder-tools/"
}, {
  parent: LAYOUT_MENU_ITEM_IDS.Product,
  id: LAYOUT_MENU_ITEM_IDS.BuyerDiscovery,
  title: {
    rendered: "Buyer Discovery"
  },
  url: "/new-construction-advertising/buyer-discovery/",
  path: "/new-construction-advertising/buyer-discovery/"
}, {
  parent: 0,
  id: LAYOUT_MENU_ITEM_IDS.Resources,
  title: {
    rendered: "Resources"
  },
  url: "/new-construction-advertising/resources/",
  path: "/new-construction-advertising/resources/"
}];
const HEADER_CTAS = {
  primary: {
    label: "Contact us",
    url: "/new-construction-advertising/"
  },
  secondary: {
    label: "Builder dashboard",
    url: "https://builders.zillowgroup.com/login/"
  }
};
const FOOTER_COLUMNS = [{
  title: "Advertising",
  description: "",
  // Column label only, no description
  links: [{
    title: "New construction and home builder advertising",
    url: "/new-construction-advertising/"
  }]
}, {
  title: "Products",
  description: "",
  // Column label only, no description
  links: [{
    title: "Attract more buyers",
    url: "/new-construction-advertising/products/"
  }, {
    title: "Builder tools",
    url: "/new-construction-advertising/builder-tools/"
  }, {
    title: "Buyer discovery",
    url: "/new-construction-advertising/buyer-discovery/"
  }]
}, {
  title: "Resources",
  description: "",
  // Column label only, no description
  links: [{
    title: "Builder dashboard",
    url: "https://builders.zillowgroup.com/login/"
  }, {
    title: "New construction resource center",
    url: "/new-construction-advertising/resources/"
  }]
}];
export {
  FOOTER_COLUMNS,
  HEADER_CTAS,
  LAYOUT_MENU_ITEMS,
  LAYOUT_MENU_ITEM_IDS
};
